import * as React from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
  TranscriptionDialogContext,
  type GuitarSettings,
} from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';
import { useNextStepAfterUpdate } from '../Wizard/Wizard.hooks';
import SelectionComponent from './SelectionComponent';

export interface GuitarStyleProps {}

const GuitarStyle: React.FC<GuitarStyleProps> = () => {
  const next = useNextStepAfterUpdate();
  const { t } = useTranslation();
  const { settings } = useContext(TranscriptionDialogContext);
  const handleClick = (style: Partial<GuitarSettings['style']>) => {
    next({ style: style ?? 'finger_picking' }, settings.instruments[0]);
  };

  const answers = [
    { title: t('home.input.dialog.style_guitar.strumming'), key: 'strumming' },
    { title: t('home.input.dialog.style_guitar.finger_picking'), key: 'finger_picking' },
    { title: t('home.input.dialog.unknown'), key: null },
  ];
  return <SelectionComponent answers={answers} handleClick={handleClick} id="style_guitar" />;
};

export default GuitarStyle;
